import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import {
  getInteractionsApiCall,
  getVideoComments,
  getVodDetailApi,
  getVodList,
  postVideoComment,
  postViewInteraction,
  likeApicall,
  unLikeApiCall,
  deleteVideoComment
} from "../../api/api";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { MainContext } from "../../context/mainContext";
import YouTube from "react-youtube";
import moment from "moment";
import likedIcon from "../../assets/images/like_filled.png";
import unLikedIcon from "../../assets/images/like_empty_black.png";
import VodItem from "../vodItem";
import { urlify } from "../../utils/urlify";
import Comment from "../comment";
import InfiniteScroll from "react-infinite-scroll-component";
import { Cookies } from "../../utils/cookies";

const options = {
  fill: true,
  fluid: true,
  responsive: true,
  preload: "none",
  controls: true,
  liveui: false,
  autoplay: true
};

const VodDetail = () => {
  const [vod, setVod] = useState(null);
  const [relatedVods, setRelatedVods] = useState([]);
  const [discoverVods, setDiscoverVods] = useState([]);
  const [comments, setComments] = useState([]);
  const [likeCount, setLikeCount] = useState(0);
  const [view, setView] = useState();
  const [userComment, setUserComment] = useState("");
  const [isFavorite, setIsFavorite] = useState(false);
  const { currentUser } = useContext(MainContext);
  const playerRef = useRef(null);
  const containerRef = useRef(null);
  const parentElRef = useRef(null);
  const commentRef = useRef(null);
  const history = useHistory();
  let { id } = useParams();

  const getVodDetail = async () => {
    const { data } = await getVodDetailApi(id);
    if (data.videoType === "original") {
      if (!playerRef.current) {
        createPlayer(data);
      } else {
        let playUrl;
        if (data.sourceInfo.embedCode?.DASH) {
          playUrl = data.sourceInfo.embedCode?.DASH;
        } else if (data.sourceInfo.embedCode?.HLS) {
          playUrl = data.sourceInfo.embedCode?.HLS;
        }
        initPlayer(playUrl);
      }
    } else {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    }
    setVod(data);
    getRelatedVods();
    getDiscoverVods();
    getComments(data.iKey);
    getInteractions(data.iKey);
    postView(data.iKey);
  };

  const postView = async (iKey) => {
    const { data } = await postViewInteraction(iKey);
  };

  const createPlayer = (data) => {
    let videoEl = document.createElement("video");
    videoEl.classList.add("video-js");
    videoEl.classList.add("vjs-big-play-centered");

    videoEl.setAttribute("id", `video-player`);
    document.getElementById(`player-div`).appendChild(videoEl);

    let playUrl;
    if (data.sourceInfo.embedCode?.DASH) {
      playUrl = data.sourceInfo.embedCode?.DASH;
    } else if (data.sourceInfo.embedCode?.HLS) {
      playUrl = data.sourceInfo.embedCode?.HLS;
    }

    playUrl && initPlayer(playUrl);
  };

  const getRelatedVods = async () => {
    let relatedId = localStorage.getItem("relatedId");
    const { data } = await getVodList(relatedId, id);
    if (data?.items) {
      setRelatedVods(data.items);
    }
  };

  const getDiscoverVods = async () => {
    let discoverId = localStorage.setItem("discoverId");
    const { data } = await getVodList(discoverId, id);
    if (data?.items) {
      setDiscoverVods(data.items);
    }
  };

  const initPlayer = (playUrl) => {
    playerRef.current = videojs(
      document.getElementById("video-player"),
      options
    );

    playerRef.current.src([
      {
        src: playUrl,
        type: playUrl.includes(".m3u8")
          ? "application/x-mpegURL"
          : "application/dash+xml"
      }
    ]);
  };

  const getComments = async (iKey) => {
    const { data } = await getVideoComments(iKey);
    if (data?.items) {
      setComments(data.items);
    }
  };

  const sendComment = async (comment) => {
    const { data } = await postVideoComment(vod.iKey, comment);
    setUserComment("");
    getComments(vod?.iKey);
  };

  const deleteComment = async (id) => {
    const { data } = await deleteVideoComment(id);
    getComments(vod?.iKey);
  };

  const getInteractions = async (iKey) => {
    const { data } = await getInteractionsApiCall(iKey);
    if (data.stats?.like) {
      setLikeCount(data.stats?.like);
    }

    if (data.stats?.view) {
      setView(data.stats?.view);
    }
    setIsFavorite(data.isLiked);
  };

  const likeVod = async (iKey) => {
    const { data } = await likeApicall(iKey);
    let cnt = likeCount;
    setLikeCount(++cnt);
  };

  const unlikeVod = async (iKey) => {
    const { data } = await unLikeApiCall(iKey);
    let cnt = likeCount;
    setLikeCount(--cnt);
  };

  const renderedCommentItems = comments?.map((item, index) => {
    return (
      <Comment
        item={item}
        currentUser={currentUser}
        deleteComment={(val) => deleteComment(val)}
        mention={(val) => {
          setUserComment(`@${val.username} `);
          commentRef.current.focus();
        }}
        isLast={index === comments.length - 1}
      />
    );
  });

  useEffect(() => {
    if (id) {
      window.scrollTo(0, 0);
      getVodDetail();
    }
  }, [id]);

  return (
    <div className="voddetail-container" ref={parentElRef}>
      <div style={{ display: "flex" }}>
        <div className="video-container" ref={containerRef}>
          <div id="player-div">
            {vod?.videoType === "youtube" ? (
              <YouTube
                videoId={vod?.sourceInfo.youtubeId}
                opts={{
                  width: containerRef.current.offsetWidth - 100,
                  height: ((containerRef.current.offsetWidth - 100) * 9) / 16
                }}
              />
            ) : null}
          </div>
          <div className="vod-info">
            <div className="vod-title">{vod?.title}</div>
            <div className="wrapper">
              <div className="date">
                {/* {view} görüntülenme &nbsp; | &nbsp; */}
                {moment(vod?.recordTime?.created * 1000).format("DD MMM yyyy")}
              </div>
              <div
                className="like"
                onClick={() => {
                  isFavorite ? unlikeVod(vod?.iKey) : likeVod(vod?.iKey);
                  setIsFavorite(!isFavorite);
                }}
              >
                <img src={isFavorite ? likedIcon : unLikedIcon} />
                <span>{likeCount}</span>
              </div>
            </div>
            <div
              className="vod-desc"
              dangerouslySetInnerHTML={{
                __html: vod && urlify(vod?.description)
              }}
            ></div>
          </div>

          <div className="seperate medium"></div>

          <div className="comment-container">
            <div className="comment-item">
              <div
                className="profile-logo"
                style={{
                  backgroundImage: `url(${currentUser?.user.photoUrl})`
                }}
              ></div>
              <div className="comment-desc">
                <div className="username" style={{ fontSize: "20px" }}>
                  {currentUser?.user.username}
                </div>
                <div className="description">
                  <textarea
                    ref={commentRef}
                    className="description"
                    placeholder="Yorum ekle..."
                    onInput={(e) => setUserComment(e.target.value)}
                    value={userComment}
                    rows="1"
                  />
                </div>
                <button
                  className="btn btn-comment"
                  onClick={() => {
                    if (!!userComment) {
                      sendComment(userComment);
                    }
                  }}
                >
                  Gönder
                </button>
              </div>
            </div>

            {/* <div className="seperate medium" style={{ marginTop: "0" }}></div> */}
            <InfiniteScroll
              dataLength={renderedCommentItems.length}
              // next={setRenderedColumn}
              hasMore={true}
            >
              {renderedCommentItems}
            </InfiniteScroll>
          </div>
        </div>
        <div className="related-container">
          <div className="box">
            <div className="vod-item-title">İLGİLİ VİDEOLAR</div>
            <div className="related">
              {relatedVods?.map((item) => {
                return <VodItem key={`related-${item.id}`} item={item} />;
              })}
            </div>
          </div>

          <div className="box">
            <div className="vod-item-title">KEŞFET</div>
            <div className="scroll">
              {discoverVods?.map((item) => {
                return <VodItem key={`discover-${item.id}`} item={item} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VodDetail;
